import $ from 'jquery'
import SmoothScroll from 'smooth-scroll'

const Education = (() => {
  const init = () => {
    var scroll = new SmoothScroll()

    $('#pathwaysToggle').on('click', function(e) {
      e.preventDefault();
      $('.c-education-main').fadeOut(0);
      $('.c-education-pathways').fadeIn(0);
    })

    $('.erepspathToggle').on('click', function(e) {
      e.preventDefault();
      $('.c-education-main').fadeOut(0);
      $('.c-pathways-select').fadeIn(0);
      $('#wtaPath').fadeOut(0);
      $('#erepsPath').fadeIn(0);
      $('.c-pathways-select li').removeClass('active');
      $('.erepspathToggle').addClass('active');
      scroll.animateScroll(500)
    })

    $('.wtapathToggle').on('click', function(e) {
      e.preventDefault();
      $('.c-education-main').fadeOut(0);
      $('.c-pathways-select').fadeIn(0);
      $('#wtaPath').fadeIn(0);
      $('#erepsPath').fadeOut(0);
      $('.c-pathways-select li').removeClass('active');
      $('.wtapathToggle').addClass('active');
      scroll.animateScroll(500)
    })

    $('.workoutToggle').on('click', function(e) {
      e.preventDefault();
      $('.c-education-main').fadeOut(0);
      $('.c-pathways-select').fadeIn(0);
      $('.c-title-select').fadeIn(0);
      $('#workout').fadeIn(0);
      $('#workoutPack').fadeOut(0);
      $('#challenge').fadeOut(0);
      $('#workoutTitle').fadeIn(0);
      $('#workoutPackTitle').fadeOut(0);
      $('#challengeTitle').fadeOut(0);
      $('#challengeCategories').fadeOut(0);
      $('.c-pathways-select li').removeClass('active');
      $('.workoutToggle').addClass('active');
      // scroll.animateScroll(500)
    })

    $('.workoutPackToggle').on('click', function(e) {
      e.preventDefault();
      $('.c-education-main').fadeOut(0);
      $('.c-pathways-select').fadeIn(0);
      $('.c-title-select').fadeIn(0);
      $('#workoutPack').fadeIn(0);
      $('#workout').fadeOut(0);
      $('#challenge').fadeOut(0);
      $('#workoutPackTitle').fadeIn(0);
      $('#workoutTitle').fadeOut(0);
      $('#challengeTitle').fadeOut(0);
      $('#challengeCategories').fadeOut(0);
      $('.c-pathways-select li').removeClass('active');
      $('.workoutPackToggle').addClass('active');
      // scroll.animateScroll(500)
    })

    $('.challengeToggle').on('click', function(e) {
      e.preventDefault();
      $('.c-education-main').fadeOut(0);
      $('.c-pathways-select').fadeIn(0);
      $('.c-title-select').fadeIn(0);
      $('#challenge').fadeIn(0);
      $('#workout').fadeOut(0);
      $('#workoutPack').fadeOut(0);
      $('#challengeTitle').fadeIn(0);
      $('#challengeCategories').fadeIn(0);
      $('#workoutTitle').fadeOut(0);
      $('#workoutPackTitle').fadeOut(0);
      $('.c-pathways-select li').removeClass('active');
      $('.challengeToggle').addClass('active');
      // scroll.animateScroll(500)
    })

    $('.workoutObiettiviEsteticiToggle').on('click', function(e) {
      e.preventDefault();
      $('.c-workout-category').fadeOut(0);
      $('.c-pathways-workout-select').fadeIn(0);
      $('#workoutObiettiviEstetici').fadeIn(0);
      $('#workoutSaluteBenessere').fadeOut(0);
      $('#workoutPreparazioneAtletica').fadeOut(0);
      $('#workoutProgrammiSpecifici').fadeOut(0);
      $('.c-pathways-workout-select li').removeClass('active');
      $('.workoutObiettiviEsteticiToggle').addClass('active');
    })

    $('.workoutSaluteBenessereToggle').on('click', function(e) {
      e.preventDefault();
      $('.c-workout-category').fadeOut(0);
      $('.c-pathways-workout-select').fadeIn(0);
      $('#workoutObiettiviEstetici').fadeOut(0);
      $('#workoutSaluteBenessere').fadeIn(0);
      $('#workoutPreparazioneAtletica').fadeOut(0);
      $('#workoutProgrammiSpecifici').fadeOut(0);
      $('.c-pathways-workout-select li').removeClass('active');
      $('.workoutSaluteBenessereToggle').addClass('active');
    })

    $('.workoutPreparazioneAtleticaToggle').on('click', function(e) {
      e.preventDefault();
      $('.c-workout-category').fadeOut(0);
      $('.c-pathways-workout-select').fadeIn(0);
      $('#workoutObiettiviEstetici').fadeOut(0);
      $('#workoutSaluteBenessere').fadeOut(0);
      $('#workoutPreparazioneAtletica').fadeIn(0);
      $('#workoutProgrammiSpecifici').fadeOut(0);
      $('.c-pathways-workout-select li').removeClass('active');
      $('.workoutPreparazioneAtleticaToggle').addClass('active');
    })

    $('.workoutProgrammiSpecificiToggle').on('click', function(e) {
      e.preventDefault();
      $('.c-workout-category').fadeOut(0);
      $('.c-pathways-workout-select').fadeIn(0);
      $('#workoutObiettiviEstetici').fadeOut(0);
      $('#workoutSaluteBenessere').fadeOut(0);
      $('#workoutPreparazioneAtletica').fadeOut(0);
      $('#workoutProgrammiSpecifici').fadeIn(0);
      $('.c-pathways-workout-select li').removeClass('active');
      $('.workoutProgrammiSpecificiToggle').addClass('active');
    })

    $('.erepsblockToggle').on('click', function(e) {
      e.preventDefault();
      scroll.animateScroll(500)
    })

    $('.wtablockToggle').on('click', function(e) {
      e.preventDefault();
      scroll.animateScroll(500)
    })    

    $('.js-challenge-category').change(function(e) {
      e.preventDefault()
      const category = $(this).val()
      if(category != 'all') {
        $('.js-challenge').each(function(e) {
          if($(this).attr('data-category') != category){
            $(this).hide()
          }else{
            $(this).show()
          }
        })
      } else {
        $('.js-challenge').each(function(e) {
          $(this).show()
        })
      }
    })
  
  }

  return {
    init
  }
})()

export default Education



// WEBPACK FOOTER //
// app/javascript/scripts/components/Education.js